// extracted by mini-css-extract-plugin
export default {"wrapper":"ThreeByOneUnit_wrapper__Hy1on"};